import { useInvalidation } from 'api-read-hook';
import { useForm } from 'react-typed-form';
import { Api, useApiFormSubmit } from 'src/api';
import { useSelectedCompany } from 'src/contexts';
import {
  FieldRadioGroup,
  FieldTextRequired,
  SubmitButton,
  createFormValidator,
} from 'src/form';

import { Modal, Stack } from '../../../components';
import { Style } from '../../../constants';

const CATEGORIES = ['Design Files', 'Design Documents', 'UI Kit'] as const;

type Props = {
  existing: Api.DesignResource.V | null;
  onClose: () => void;
};

export default function AddResourceModal({ existing, onClose }: Props) {
  const { invalidateExact } = useInvalidation();
  const company = useSelectedCompany();

  const form = useForm<Api.DesignResource.W_Create>({
    defaultValues: existing
      ? {
          ...existing,
          company: `/companies/${company.id}`,
        }
      : {
          company: `/companies/${company.id}`,
          title: '',
          category: null,
          link: '',
        },
    validator: createFormValidator({
      category: { strictPresence: { message: '^Please choose a type' } },
      link: { strictPresence: { message: '^Please enter a link' } },
      title: { strictPresence: { message: '^Please enter a title' } },
    }),
    onSubmit: useApiFormSubmit(
      existing ? 'PATCH' : 'POST',
      existing ? `/design-resources/${existing.id}` : '/design-resources',
      {
        onSuccess: () => {
          onClose();
          invalidateExact(`/companies/${company.id}/design-resources`);
        },
      }
    ),
  });

  return (
    <Modal title="Add File" onClose={onClose} fullScreenOnMobile>
      <Stack padH={1.5} padV={1.5} gap={1.5}>
        <FieldRadioGroup
          label="Types"
          field={form.getField('category')}
          options={CATEGORIES.map((cat) => ({
            value: cat,
            label: cat,
          }))}
        />

        <FieldTextRequired
          field={form.getField('link')}
          placeholder="https://..."
        />

        <FieldTextRequired
          field={form.getField('title')}
          placeholder="Enter a title"
        />
      </Stack>

      {/* Footer */}
      <Stack padH padV style={Style.alignEnd}>
        <SubmitButton {...form} />
      </Stack>
    </Modal>
  );
}
